export default "__VITE_ASSET__C0QV4d$J__"